
const EditIcon = ({ 
  size = 16, 
  color = 'currentColor', 
  className = '', 
  onClick,
  style = {} 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      className={`edit-icon ${className}`}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
    >
      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"/>
    </svg>
  );
};

export function TableRow({ userInfo, handleEditUser}) {

    let user = userInfo.info;
    return (
        <tr key={user.id} className="admin-user-row">
            <td className="admin-user-email">{user.email}</td>
            <td>
                <span className={`admin-role-badge admin-role-${user.roles[0].trim().toLowerCase().replace(/\s/g, '')}`}>
                    {user.roles[0]}
                </span>
            </td>
            <td className="admin-actions">
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                    <lui-button
                        variant="secondary"
                        size="medium"
                        onClick={() => handleEditUser(user)}
                        class='edit-btn'
                        title="Edit user">
                        <EditIcon size={16} />
                        
                    </lui-button>
                </div>
            </td>
        </tr>
    );
}